import { useTranslation } from "react-i18next";

export default function BooleanStatsPanel({ title, stats }) {
  const { t } = useTranslation();

  return (
    <div className="rounded-xl border border-slate-200 bg-slate-50/70 p-4">
      <div className="text-sm font-medium text-slate-900">{title}</div>
      <div className="text-xs text-slate-500 mt-1 uppercase tracking-wide">
        boolean
      </div>

      <div className="grid grid-cols-2 gap-3 mt-4">
        <div className="rounded-lg bg-white border border-slate-200 p-3">
          <div className="text-xs text-slate-500">
            {t("dashboard.stats.total", "Total")}
          </div>
          <div className="text-xl font-semibold text-slate-900 mt-1">
            {stats?.total ?? 0}
          </div>
        </div>
        <div className="rounded-lg bg-white border border-slate-200 p-3">
          <div className="text-xs text-slate-500">
            {t("dashboard.stats.responses", "Respostes")}
          </div>
          <div className="text-xl font-semibold text-slate-900 mt-1">
            {stats?.answered ?? 0}
          </div>
        </div>
        <div className="rounded-lg bg-white border border-slate-200 p-3">
          <div className="text-xs text-slate-500">
            {t("common.yes", "Sí")}
          </div>
          <div className="text-xl font-semibold text-slate-900 mt-1">
            {stats?.yes ?? 0}
          </div>
          <div className="text-sm text-slate-500 mt-1">
            {stats?.yes_pct ?? 0}%
          </div>
        </div>
        <div className="rounded-lg bg-white border border-slate-200 p-3">
          <div className="text-xs text-slate-500">
            {t("common.no", "No")}
          </div>
          <div className="text-xl font-semibold text-slate-900 mt-1">
            {stats?.no ?? 0}
          </div>
          <div className="text-sm text-slate-500 mt-1">
            {stats?.no_pct ?? 0}%
          </div>
        </div>
      </div>

      <div className="mt-3 rounded-lg bg-white border border-slate-200 p-3">
        <div className="text-xs text-slate-500">
          {t("dashboard.stats.empty", "Buides")}
        </div>
        <div className="text-xl font-semibold text-slate-900 mt-1">
          {stats?.empty ?? 0}
        </div>
      </div>
    </div>
  );
}
